import EventBus, {ACTIONS} from './event-bus';

export const showSnackbar = (color, ...data) => {
    EventBus.$emit(ACTIONS.SNACKBAR, data, color);
};

export const parseLaravelError = (error) => {
    return Object.keys(error.data.errors).map(key => {
        return error.data.errors[key][0]
    })
}
